import IconContainer from '@/components/IconContainer'

export default function IconFastForward(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Fast Forward Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M8.24994 1.8128C7.95705 2.10569 7.95705 2.58057 8.24994 2.87346L13.3765 7.99998L8.24995 13.1265C7.95705 13.4194 7.95705 13.8943 8.24995 14.1872C8.54284 14.4801 9.01771 14.4801 9.31061 14.1872L15.4978 7.99998L9.3106 1.8128C9.01771 1.51991 8.54284 1.51991 8.24994 1.8128Z" />
      <path d="M2.6894 1.8128C2.3965 2.10569 2.3965 2.58057 2.6894 2.87346L7.81592 7.99998L2.6894 13.1265C2.39651 13.4194 2.39651 13.8943 2.6894 14.1872C2.98229 14.4801 3.45717 14.4801 3.75006 14.1872L9.93724 7.99998L3.75006 1.8128C3.45716 1.51991 2.98229 1.51991 2.6894 1.8128Z" />
    </IconContainer>
  )
}
